import { SubscriptionType } from '../types/misc';
import { subscriptionService } from '../services/subscriptionService';
import { CommunicationType } from '../types/communication';

export const useSubscriptionOptions = () => {
  return [SubscriptionType.FREE, SubscriptionType.BASE, SubscriptionType.PRO];
};

export const subscriptionFeatures = [
  // Free
  {
    i18nKey: 'sharingBetweenMembers',
    [SubscriptionType.FREE]: true,
    [SubscriptionType.BASE]: true,
    [SubscriptionType.PRO]: true,
    isComingSoon: false,
  },
  {
    i18nKey: 'events',
    [SubscriptionType.FREE]: true,
    [SubscriptionType.BASE]: true,
    [SubscriptionType.PRO]: true,
    isComingSoon: false,
  },
  {
    i18nKey: 'tasks',
    [SubscriptionType.FREE]: true,
    [SubscriptionType.BASE]: true,
    [SubscriptionType.PRO]: true,
    isComingSoon: false,
  },
  {
    i18nKey: 'scores',
    [SubscriptionType.FREE]: true,
    [SubscriptionType.BASE]: true,
    [SubscriptionType.PRO]: true,
    isComingSoon: false,
  },
  {
    i18nKey: 'costSplittingApp',
    [SubscriptionType.FREE]: true,
    [SubscriptionType.BASE]: true,
    [SubscriptionType.PRO]: true,
    isComingSoon: false,
  },
  {
    i18nKey: 'memberAdministration',
    [SubscriptionType.FREE]: true,
    [SubscriptionType.BASE]: true,
    [SubscriptionType.PRO]: true,
    isComingSoon: false,
  },
  {
    i18nKey: 'maxPhotos200',
    [SubscriptionType.FREE]: true,
    [SubscriptionType.BASE]: true,
    [SubscriptionType.PRO]: true,
    isComingSoon: false,
  },
  // Base
  {
    i18nKey: 'attendanceInsightAndExport',
    [SubscriptionType.FREE]: false,
    [SubscriptionType.BASE]: true,
    [SubscriptionType.PRO]: true,
    isComingSoon: false,
  },
  {
    i18nKey: 'externalCalendars',
    [SubscriptionType.FREE]: false,
    [SubscriptionType.BASE]: true,
    [SubscriptionType.PRO]: true,
    isComingSoon: false,
  },
  {
    i18nKey: 'basicFinancialAdministration',
    [SubscriptionType.FREE]: false,
    [SubscriptionType.BASE]: true,
    [SubscriptionType.PRO]: true,
    isComingSoon: false,
  },
  {
    i18nKey: 'monthlyEmails500',
    [SubscriptionType.FREE]: false,
    [SubscriptionType.BASE]: true,
    [SubscriptionType.PRO]: true,
    isComingSoon: false,
  },
  {
    i18nKey: 'maxPhotos1000',
    [SubscriptionType.FREE]: false,
    [SubscriptionType.BASE]: true,
    [SubscriptionType.PRO]: true,
    isComingSoon: false,
  },
  // Pro
  {
    i18nKey: 'psd2BankConnection',
    [SubscriptionType.FREE]: false,
    [SubscriptionType.BASE]: false,
    [SubscriptionType.PRO]: true,
    isComingSoon: true,
  },
  {
    i18nKey: 'savingPots',
    [SubscriptionType.FREE]: false,
    [SubscriptionType.BASE]: false,
    [SubscriptionType.PRO]: true,
    isComingSoon: true,
  },
  {
    i18nKey: 'budgetsPandLBalance',
    [SubscriptionType.FREE]: false,
    [SubscriptionType.BASE]: false,
    [SubscriptionType.PRO]: true,
    isComingSoon: true,
  },
  {
    i18nKey: 'monthlyEmails1000',
    [SubscriptionType.FREE]: false,
    [SubscriptionType.BASE]: false,
    [SubscriptionType.PRO]: true,
    isComingSoon: true,
  },
  {
    i18nKey: 'maxPhotos5000',
    [SubscriptionType.FREE]: false,
    [SubscriptionType.BASE]: false,
    [SubscriptionType.PRO]: true,
    isComingSoon: false,
  }
];

export const baseSubscriptionPrices = {
  [SubscriptionType.FREE]: 0,
  [SubscriptionType.BASE]: 7.5,
  [SubscriptionType.PRO]: 12.5,
};

export const variableSubscriptionPrices = {
  [SubscriptionType.FREE]: 0,
  [SubscriptionType.BASE]: 0.05,
  [SubscriptionType.PRO]: 0.1,
};

export async function downloadInvoice(invoiceId: string) {
  const blob = await subscriptionService.fetchInvoicePdf(invoiceId);

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `invoice_${invoiceId}.pdf`;
  a.click();
  window.URL.revokeObjectURL(url);
}

export function isSubscriptionGreaterThanOrEqual(
  subscription: SubscriptionType,
  requiredSubscription: SubscriptionType,
): boolean {
  const subscriptionOrder: SubscriptionType[] = [
    SubscriptionType.FREE,
    SubscriptionType.BASE,
    SubscriptionType.PRO,
  ];

  return subscriptionOrder.indexOf(subscription) >= subscriptionOrder.indexOf(requiredSubscription);
}

export function isSubscriptionGreaterThan(
  subscription: SubscriptionType,
  requiredSubscription: SubscriptionType,
): boolean {
  const subscriptionOrder: SubscriptionType[] = [
    SubscriptionType.FREE,
    SubscriptionType.BASE,
    SubscriptionType.PRO,
  ];

  return subscriptionOrder.indexOf(subscription) > subscriptionOrder.indexOf(requiredSubscription);
}

export function hasRequiredSubscriptionForCommunication(
  type: CommunicationType,
  subscription: SubscriptionType,
): boolean {
  return (
    type === CommunicationType.POSTCARD ||
    ((type === CommunicationType.EMAIL || type === CommunicationType.NOTIFICATION) &&
      subscription !== SubscriptionType.FREE)
  );
}
